// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"aR","arrowBtnBox":"aR","arrow-btn-wrap-box":"aS","arrowBtnWrapBox":"aS","arrow-btn-text":"aT","arrowBtnText":"aT","arrow-btn-arrow":"aU","arrowBtnArrow":"aU"};